<div id="footer" class="container">
    <header class="major">
        <h2><a [routerLink]="['/contact']" i18n>Kontaktieren Sie uns unverbindlich!</a></h2>
        <p i18n>Sind Sie auf der Suche nach einem verlässlichen Partner für Ihr Software-, Webseiten- oder KI-Projekt?<br>
            Haben Sie Fragen, Anregungen oder benötigen Unterstützung?<br>
            Zögern Sie nicht, uns zu kontaktieren!<br>
            Wir freuen uns auf Ihre Anfrage.<br>
        </p>
    </header>
</div>
